$().ready(function () {

    $(".twentytwenty-container").each(function() {
   
    var orientationData = $(this).attr("orientation");    

    $(this).twentytwenty({
        default_offset_pct: 0.5, // hard coded
        orientation: orientationData, // configuraable in sitecore - Orientation of the before and after images ('horizontal' or 'vertical')
        before_label: '', // hard coded
        after_label: '', // hard coded
        no_overlay: true, // hard coded
        move_slider_on_hover: false, // hard coded
        move_with_handle_only: true, // hard coded
        click_to_move: false });// hard coded
});
});